import { render, staticRenderFns } from "./html.vue?vue&type=template&id=4f16f870"
import script from "./html.js?vue&type=script&lang=js&external"
export * from "./html.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports